export default function (state = null, action) {
    switch (action.type) {
        case 'DEPARTMENT_TOGGLE':
            return action.payload;
        default:
            return state;
    }
}